import { PagedRequestType, PagedResultsType } from "../../../types/PagedResults";
import { get, post } from "../../../utils/axios-config";
import { DEPARTAMENTS, DEPARTAMENTS_BY_IDS_COURSES } from "../../../utils/constants";
import { DepartamentType } from "../../../types/Departament";

export const getDepartaments = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.IdFaculty ? { IdFaculty: data.IdFaculty } : {}),
    });
    const url = `${DEPARTAMENTS}?${queryParams.toString()}`;
    return await get<PagedResultsType<DepartamentType>>(url)
};


export const getDepartamentsByIdCourses = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.IdFaculty ? { IdFaculty: data.IdFaculty } : {}),
    });
    const url = `${DEPARTAMENTS_BY_IDS_COURSES}?${queryParams.toString()}`;
    return await post<string[],PagedResultsType<DepartamentType>>(url, data?.IdsCourses!)
};